import React from "react";
import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import loginIllustration from "../../../Assets/login.png";
import icon from "../../../Assets/icon_white.png";
import { Checked, UnChecked } from "../../../Assets/icons";
import { translation } from "../../../i18n/translationConstant";

import "./index.css";

const WebViewPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="webViewPageRoot">

      {/* =====================================================
          BACKGROUND DECORATION
          ===================================================== */}

      <div className="webViewPageDecor webViewPageDecorTop" />
      <div className="webViewPageDecor webViewPageDecorBottom" />


      {/* =====================================================
          BRAND
          ===================================================== */}

      <div className="webViewBrandBlock">

        <img
          className="webViewBrandLogo"
          src={icon}
          alt="INK Account Aggregator"
        />

        <Typography.Text className="webViewBrandTagline">
          {t(translation.lblOneConsentSmarterYou)}
        </Typography.Text>

      </div>


      {/* =====================================================
          WELCOME CONTENT
          ===================================================== */}

      <div className="webViewWelcomeContent">

        <Typography.Title
          level={1}
          className="webViewWelcomeTitle"
        >
          {t(translation.lblWelcomeBack)}
          <br />
          {t(translation.lblToInk)}
        </Typography.Title>

        <Typography.Paragraph
          className="webViewWelcomeDescription"
        >
          {t(translation.lblSecurelyAccessAccount)}
          <br />
          {t(translation.lblManageFinancialData)}
          <br />
          {t(translation.lblTrustedInstitutions)}
        </Typography.Paragraph>

      </div>


      {/* =====================================================
          ILLUSTRATION
          ===================================================== */}

      <div className="webViewIllustrationWrapper">

        <img
          src={loginIllustration}
          className="webViewIllustration"
          alt="Securely manage your financial data with INK-AA"
        />

      </div>


      {/* =====================================================
          CONSENT JOURNEY
          ===================================================== */}

      <div className="webViewConsentBanner">

        {/* ---------------------------------------------------
            CONSENT HEADER
            --------------------------------------------------- */}

        <div className="webViewConsentHeader">

          <div className="webViewConsentHeaderText">

            <Typography.Text className="webViewConsentTitle">
              {t("Consents")}
            </Typography.Text>

            <Typography.Text className="webViewConsentSubtitle">
              {t("lblapproveconsent")}
            </Typography.Text>

          </div>


          <div className="webViewConsentSecureBadge">

            <span className="webViewConsentSecureIcon">
              ✓
            </span>

            <span>
              {t(translation.lblSecure)}
            </span>

          </div>

        </div>


        {/* ---------------------------------------------------
            STEPS
            --------------------------------------------------- */}

        <div className="webViewConsentSteps">

          {/* STEP 1 */}

          <div className="webViewConsentStep completed">

            <div className="webViewConsentStepNumber">
              1
            </div>

            <div className="webViewConsentStepContent">

              <Typography.Text className="webViewConsentStepTitle">
                {t("lblConsentreqRaised")}
              </Typography.Text>

              <Typography.Text className="webViewConsentStepDescription">
                {t("lblConsentreqinitiated")}
              </Typography.Text>

            </div>

            <div className="webViewConsentStepStatus">
              <Checked />
            </div>

          </div>


          {/* CONNECTOR */}

          <div className="webViewConsentConnector" />


          {/* STEP 2 */}

          <div className="webViewConsentStep active">

            <div className="webViewConsentStepNumber">
              2
            </div>

            <div className="webViewConsentStepContent">

              <Typography.Text className="webViewConsentStepTitle">
                {t("lblEnterOTP")}
              </Typography.Text>

              <Typography.Text className="webViewConsentStepDescription">
                {t("lblVerifyMobileNumber")}
              </Typography.Text>

            </div>

            <div className="webViewConsentStepStatus">
              <Checked />
            </div>

          </div>


          {/* CONNECTOR */}

          <div className="webViewConsentConnector" />


          {/* STEP 3 */}

          <div className="webViewConsentStep pending">

            <div className="webViewConsentStepNumber">
              3
            </div>

            <div className="webViewConsentStepContent">

              <Typography.Text className="webViewConsentStepTitle">
                {t("lblApproveConsent")}
              </Typography.Text>

              <Typography.Text className="webViewConsentStepDescription">
                {t("lblFinalApprovalPending")}
              </Typography.Text>

            </div>

            <div className="webViewConsentStepStatus">
              <UnChecked />
            </div>

          </div>

        </div>

      </div>


      {/* =====================================================
          TRUST POINTS
          ===================================================== */}

      <div className="webViewTrustPoints">

        {/* ---------------------------------------------------
            YOUR DATA
            --------------------------------------------------- */}

        <div className="webViewTrustPoint">

          <div className="webViewTrustPointIcon">
            ✓
          </div>

          <div className="webViewTrustPointText">

            <span className="webViewTrustPointTitle">
              {t(translation.lblYourData)}
            </span>

            <span className="webViewTrustPointSubtitle">
              {t(translation.lblYourControl)}
            </span>

          </div>

        </div>


        {/* DIVIDER */}

        <div className="webViewTrustPointDivider" />


        {/* ---------------------------------------------------
            SECURE
            --------------------------------------------------- */}

        <div className="webViewTrustPoint">

          <div className="webViewTrustPointIcon">
            ♧
          </div>

          <div className="webViewTrustPointText">

            <span className="webViewTrustPointTitle">
              {t(translation.lblSecure)}
            </span>

            <span className="webViewTrustPointSubtitle">
              {t(translation.lblRbiRegulated)}
            </span>

          </div>

        </div>


        {/* DIVIDER */}

        <div className="webViewTrustPointDivider" />


        {/* ---------------------------------------------------
            TRANSPARENCY
            --------------------------------------------------- */}

        <div className="webViewTrustPoint">

          <div className="webViewTrustPointIcon">
            ▤
          </div>

          <div className="webViewTrustPointText">

            <span className="webViewTrustPointTitle">
              {t(translation.lblTransparency)}
            </span>

            <span className="webViewTrustPointSubtitle">
              {t(translation.lblAtEveryStep)}
            </span>

          </div>

        </div>

      </div>

    </div>
  );
};

export default WebViewPage;